import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';

@Component({
  selector: 'app-care-service-short-description',
  templateUrl: './care-service-short-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'my-5 block short-description',
  },
})
export class CareServiceShortDescriptionComponent {
  title = input<string>(null);
  description = input<string>(null);
  moreClick = output<boolean>();

  public onMoreClick(): void {
    this.moreClick.emit(true);
  }
}
